import { createSlice } from '@reduxjs/toolkit';
import { sar } from '../../../helpers/reduxHelper';

const getInitialState = () => ({
  name: '',
  nameError: '',
});

const configuratorOptionDetails = createSlice({
  name: 'configuratorOptionDetails',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setName: sar('name'),
    setNameError: sar('nameError'),
  },
});

export const configuratorOptionDetailsActions = configuratorOptionDetails.actions;
export const configuratorOptionDetailsReducer = configuratorOptionDetails.reducer;

export const selectName = (state) => state.configuratorOptionDetails.name;
export const selectNameError = (state) => state.configuratorOptionDetails.nameError;
